import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

export default function GsiIcon() {
  return (
    <span className={clsx('fa-layers fa-fw')}>
      <FontAwesomeIcon icon={['fal', 'prescription-bottle']} />
      <FontAwesomeIcon icon={['far', 'dna']} transform="shrink-9 right-2 down-2" />
    </span>
  );
}
